import firebase from "firebase/app";
import moment from "moment";
import { promoCodesCollection } from "@/firebase";
import storeClient from "@/store/storeClient";
import store from "@/store";

const state = {
  promoCodes: [],
  activePromoCodes: [],
};

const getters = {};

const actions = {
  async getPromoCodes({ commit }, payload) {
    await store
      .dispatch("getPromoCodesUsed", {
        client: store.state.storeClient.client.basicSettings.name,
        uid: store.state.storeAuth.user.uid,
      })
      .then(async () => {
        await promoCodesCollection
          .where("client", "==", payload)
          .orderBy("validFrom", "desc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];

            querySnapshot.forEach(doc => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });

            commit("getPromoCodes", tempData);
            commit(
              "getActivePromoCodes",
              tempData.filter(
                (x) =>
                  !store.state.storePromoCodeUsed.promoCodesUsed.includes(x.id)
              )
            );
          });
      });
  },
  addPromoCode({ commit }, payload) {
    payload.validFrom = firebase.firestore.Timestamp.fromDate(
      new Date(payload.validFrom)
    );
    payload.validTo = firebase.firestore.Timestamp.fromDate(
      new Date(payload.validTo)
    );
    promoCodesCollection.add(payload).then((docRef) => {
      commit("addPromoCode", Object.assign(payload, { id: docRef.id }));
    });
  },
  removePromoCode({ commit }, payload) {
    promoCodesCollection
      .doc(payload)
      .delete()
      .then(() => {
        commit("removePromoCode", payload);
      });
  },
  editPromoCode({ commit }, payload) {
    payload.validFrom = firebase.firestore.Timestamp.fromDate(
      new Date(payload.validFrom)
    );
    payload.validTo = firebase.firestore.Timestamp.fromDate(
      new Date(payload.validTo)
    );
    promoCodesCollection
      .doc(payload.id)
      .set(payload)
      .then(() => {
        commit("editPromoCode", payload);
      });
  },
};

const mutations = {
  getActivePromoCodes(state, payload) {
    state.activePromoCodes = payload.filter(
      (e) =>
        e.validFrom.seconds <= moment().unix() &&
        e.validTo.seconds >= moment().unix() - 86400 &&
        e.client == storeClient.state.client.basicSettings.name
    );
    //console.log(state.activePromoCodes);
  },
  getPromoCodes(state, payload) {
    state.promoCodes = payload;
  },
  addPromoCode(state, payload) {
    state.promoCodes.push(payload);
  },
  removePromoCode(state, payload) {
    const index = state.promoCodes.findIndex((item) => item.id == payload);
    state.promoCodes.splice(index, 1);
  },
  editPromoCode(state, payload) {
    const index = state.promoCodes.findIndex((item) => item.id == payload.id);
    state.promoCodes.splice(index, 1, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
